import { getDateString } from '@/plugins/globals.plugin'

const getDefaultState = () => {
  return {
    sessions: [],
    sessionsReq: null,
    loading: false,
    grouping: 0,
    sessionCounter: 0
  }
}
const state = {
  sessions: [],
  sessionsReq: null,
  loading: false,
  grouping: 0,
  sessionCounter: 0
}

const getters = {
  GET_SESSIONS: state => {
    const sessions = state.sessions

    if (sessions) {
      const sessionsMap = sessions.map(item => {
        const obj = {}
        if (item && item.start) {
          // 10.61.53.2, id: 38, tls: y, renato
          const info = item.info.split(',')
          obj.start = item.start
          obj.name = info[3].slice(1)
          obj.id = info[1].toUpperCase()
          obj.ip = info[0]
          obj.tls = info[2].toUpperCase()
          obj.date = getDateString({ date: item.start })
        }
        return obj
      })

      // Group
      const result = {}
      for (let i = 0; i < sessionsMap.length; i++) {
        let groupingKey
        if (state.grouping === 0) groupingKey = 'id'
        else if (state.grouping === 1) groupingKey = 'name'
        else groupingKey = 'ip'
        const key = sessionsMap[i][groupingKey]
        if (Object.prototype.hasOwnProperty.call(result, key)) {
          result[key].push(sessionsMap[i])
        } else result[key] = [sessionsMap[i]]
      }
      return result
    }
  }
}

const mutations = {
  SET_SESSIONS (state, payload = []) {
    state.sessions = payload
    state.sessionCounter = payload.length
  },
  SET_SESSIONS_REQ (state, payload = null) {
    state.sessionsReq = payload
  },
  SET_LOADING (state, payload = false) {
    state.loading = payload
  },
  TOGGLE_SESSION_GROUPING (state) {
    const update = state.grouping + 1
    state.grouping = update % 3
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  doResetState ({ commit, dispatch }) {
    dispatch('stop')
    commit('resetState')
  },
  async getSessions ({ commit, dispatch, rootState }) {
    try {
      const body = await rootState.hsm.instance.getSessions()
      const res = []

      body.map(line => {
        if (line && line.start) {
          res.push(line)
        }
        return null
      })

      commit('SET_SESSIONS', res)
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  start ({ commit, dispatch }) {
    // dispatch('getSessions')
    commit(
      'SET_SESSIONS_REQ',
      setInterval(() => {
        dispatch('getSessions')
      }, 2000)
    )
  },
  stop ({ state, commit }) {
    if (state.sessionsReq) {
      clearInterval(state.sessionsReq)
      commit('SET_SESSIONS_REQ')
    }
  }
}

export { state, getters, mutations, actions }
